export default {"src":"/_next/static/media/chatbot.71ab1704.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};